import Wix from './Wix';
import subscribeValue from '../utils/subscribeValue';

function syncDocumentHeightWithViewer(): Function {
  Wix.setHeight(document.body.clientHeight);

  return subscribeValue<number>(
    () => document.body.clientHeight,
    (height) => {
      Wix.setHeight(height);
    },
  );
}

export default syncDocumentHeightWithViewer;
